function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "B8027122-4044-420C-B3C8-57D0D7502C4A");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Klientska-zona",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Registracny-Proces_11",
  transform: "translate(-1065.000000, -1186.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(318.000000, 1162.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(747.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,0 C24.836556,-1.623249e-15 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 1.082166e-15,24.836556 0,16 C-1.082166e-15,7.163444 7.163444,1.623249e-15 16,0 Z",
  id: "Rectangle",
  fill: "#DD841A",
  opacity: 0.200000003
}), /*#__PURE__*/React.createElement("g", {
  id: "alert-triangle-2",
  transform: "translate(8.000000, 8.000000)",
  stroke: "#DD841A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "alert-triangle"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.75636364,1.37052632 L0.596363636,11.7894737 C0.337921184,12.242926 0.336378134,12.8012661 0.592310197,13.2561777 C0.848242259,13.7110893 1.32320874,13.9942451 1.84,14 L14.16,14 C14.6767913,13.9942451 15.1517577,13.7110893 15.4076898,13.2561777 C15.6636219,12.8012661 15.6620788,12.242926 15.4036364,11.7894737 L9.24363636,1.37052632 C8.97995225,0.930102026 8.50842631,0.661135997 8,0.661135997 C7.49157369,0.661135997 7.02004775,0.930102026 6.75636364,1.37052632 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 5.15789474,
  x2: 8,
  y2: 8.10526316,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 11.0526316,
  x2: 8.00727273,
  y2: 11.0526316,
  id: "Path"
})))))));

var SvgAlertCheck = function SvgAlertCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert-check.8a036089.svg";
export { ForwardRef as ReactComponent };